import mapFunction from './mapResources';

export default mapFunction('order_work_detail', {
    isFetching: false,
    items: []
});